import { etiquetaParcelas, etiquetaProducto, generoParcelas } from '../components/content/coop-config';

export const INFO_GENERAL = [
  {
    var: 'nuevo_fecha_ingreso',
    isImage: false,
    label: 'Fecha de ingreso a la organización', // config_id: 10116
  },
  {
    var: 'parcela_nueva_p1',
    isImage: false,
    label: `¿${generoParcelas('El', 'La')} ${etiquetaParcelas(['singular', 'lowercase'])} es nueva?`, // config_id: 11275
  },
  {
    var: 'inspeccion_parcela_cafe_anios',
    isImage: false,
    label: `¿Desde qué año se cultiva ${etiquetaProducto(['singular', 'lowercase'])} en est${generoParcelas()} ${etiquetaParcelas([
      'singular',
      'lowercase',
    ])}?`, // config_id: 10325
  },
  {
    var: 'inspeccion_parcela_cultivo_antes',
    isImage: false,
    label: `¿Qué había antes de producir ${etiquetaProducto(['singular', 'lowercase'])} en ${generoParcelas(
      'el',
      'la'
    )} ${etiquetaParcelas(['singular', 'lowercase'])}?`, // config_id: 10323
  },
  {
    var: 'inspeccion_parcela_cultivo_antes_otro',
    isImage: false,
    label: `Escriba el otro cultivo antes de tener ${etiquetaProducto([
      'singular',
      'lowercase',
    ])} en est${generoParcelas()} ${etiquetaParcelas(['singular', 'lowercase'])}`, // config_id: 10324
  },
  {
    var: 'uso_suelo_2020',
    isImage: false,
    label: '2020: Uso del suelo', // config_id: 11291
  },
  {
    var: 'inpeccion_foto',
    isImage: true,
    label: `Capture con una foto del productor/a con ${generoParcelas('el', 'la')} ${etiquetaParcelas([
      'singular',
      'lowercase',
    ])} inspeccionada`, // config_id: 11272
  },
];

export const INFO_EDADES_VARIEDADES = [
  {
    var: 'inspeccion_variedades',
    isImage: false,
    label: `Variedades de café en ${generoParcelas('el', 'la')} ${etiquetaParcelas(['singular', 'lowercase'])} inspeccionada`, // config_id: 10375
  },
  {
    var: 'edades_general',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de las plantas', // config_id: 10384
  },
  {
    var: 'edad_otro',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de la Otra variedad', // config_id: 10386
  },
  {
    var: 'edad_otro_otro',
    isImage: false,
    label: 'Otro rango de edad de Otra variedad', // config_id: 10387
  },
  {
    var: 'edad_anacafe',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Anacafe 14', // config_id: 10389
  },
  {
    var: 'edad_anacafe_otro',
    isImage: false,
    label: 'Otro rango de edad de Anacafe 14', // config_id: 10390
  },
  {
    var: 'edad_arabe',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Árabe', // config_id: 10392
  },
  {
    var: 'edad_arabe_otro',
    isImage: false,
    label: 'Otro rango de edad de Árabe', // config_id: 10393
  },
  {
    var: 'edad_bourbon',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Bourbon', // config_id: 10395
  },
  {
    var: 'edad_bourbon_otro',
    isImage: false,
    label: 'Otro rango de edad de Bourbon', // config_id: 10396
  },
  {
    var: 'edad_catimor',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Catimor', // config_id: 10398
  },
  {
    var: 'edad_catimor_otro',
    isImage: false,
    label: 'Otro rango de edad de Catimor', // config_id: 10399
  },
  {
    var: 'edad_caturra',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Caturra', // config_id: 10401
  },
  {
    var: 'edad_caturra_otro',
    isImage: false,
    label: 'Otro rango de edad de Caturra', // config_id: 10402
  },
  {
    var: 'edad_chichon',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Chichon', // config_id: 10404
  },
  {
    var: 'edad_chichon_otro',
    isImage: false,
    label: 'Otro rango de edad de Chichon', // config_id: 10405
  },
  {
    var: 'edad_chupon',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Chupón', // config_id: 10407
  },
  {
    var: 'edad_chupon_otro',
    isImage: false,
    label: 'Otro rango de edad de Chupón', // config_id: 10408
  },
  {
    var: 'edad_rica',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Costa Rica', // config_id: 10410
  },
  {
    var: 'edad_rica_otro',
    isImage: false,
    label: 'Otro rango de edad de Costa Rica', // config_id: 10411
  },
  {
    var: 'edad_garnica',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Gárnica', // config_id: 10413
  },
  {
    var: 'edad_garnica_otro',
    isImage: false,
    label: 'Otro rango de edad de Gárnica', // config_id: 10414
  },
  {
    var: 'edad_geisha',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Geisha', // config_id: 10416
  },
  {
    var: 'edad_geisha_otro',
    isImage: false,
    label: 'Otro rango de edad de Geisha', // config_id: 10417
  },
  {
    var: 'edad_marragocaturra',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Marrago Caturra', // config_id: 10419
  },
  {
    var: 'edad_marragocaturra_otro',
    isImage: false,
    label: 'Otro rango de edad de Marrago Caturra', // config_id: 10420
  },
  {
    var: 'edad_marsellesa',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Marsellesa', // config_id: 10422
  },
  {
    var: 'edad_marsellesa_otro',
    isImage: false,
    label: 'Otro rango de edad de Marsellesa', // config_id: 10423
  },
  {
    var: 'edad_moca',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Moca', // config_id: 10425
  },
  {
    var: 'edad_moca_otro',
    isImage: false,
    label: 'Otro rango de edad de Moca', // config_id: 10426
  },
  {
    var: 'edad_mundonovo',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Mundo Novo', // config_id: 10428
  },
  {
    var: 'edad_mundonovo_otro',
    isImage: false,
    label: 'Otro rango de edad de Mundo Novo', // config_id: 10429
  },
  {
    var: 'edad_obata',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Obata', // config_id: 10431
  },
  {
    var: 'edad_obata_otro',
    isImage: false,
    label: 'Otro rango de edad de Obata', // config_id: 10432
  },
  {
    var: 'edad_oroazteca',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Oro Azteca', // config_id: 10434
  },
  {
    var: 'edad_oroazteca_otro',
    isImage: false,
    label: 'Otro rango de edad de Oro Azteca', // config_id: 10435
  },
  {
    var: 'edad_pacamara',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Pacamara', // config_id: 10437
  },
  {
    var: 'edad_pacamara_otro',
    isImage: false,
    label: 'Otro rango de edad de Pacamara', // config_id: 10438
  },
  {
    var: 'edad_sarchimor',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Sarchimor', // config_id: 10440
  },
  {
    var: 'edad_sarchimor_otro',
    isImage: false,
    label: 'Otro rango de edad de Sarchimor', // config_id: 10441
  },
  {
    var: 'edad_tabi',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Tabi', // config_id: 10443
  },
  {
    var: 'edad_tabi_otro',
    isImage: false,
    label: 'Otro rango de edad de Tabi', // config_id: 10444
  },
  {
    var: 'edad_robusta',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Robusta', // config_id: 10446
  },
  {
    var: 'edad_robusta_otro',
    isImage: false,
    label: 'Otro rango de edad de Robusta', // config_id: 10447
  },
  {
    var: 'edad_catuai',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Catuai', // config_id: 10449
  },
  {
    var: 'edad_catuai_otro',
    isImage: false,
    label: 'Otro rango de edad de Catuai', // config_id: 10450
  },
  {
    var: 'edad_colombia',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Colombia', // config_id: 10452
  },
  {
    var: 'edad_colombia_otro',
    isImage: false,
    label: 'Otro rango de edad de Colombia', // config_id: 10453
  },
  {
    var: 'edad_guacamayo',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Guacamayo', // config_id: 10455
  },
  {
    var: 'edad_guacamayo_otro',
    isImage: false,
    label: 'Otro rango de edad de Guacamayo', // config_id: 10456
  },
  {
    var: 'edad_marago',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Marago', // config_id: 10458
  },
  {
    var: 'edad_marago_otro',
    isImage: false,
    label: 'Otro rango de edad de Marago', // config_id: 10459
  },
  {
    var: 'edad_najtilkab',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Najtilkab', // config_id: 10461
  },
  {
    var: 'edad_najtilkab_otro',
    isImage: false,
    label: 'Otro rango de edad de Najtilkab', // config_id: 10462
  },
  {
    var: 'edad_penasco',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Peñasco', // config_id: 10464
  },
  {
    var: 'edad_penasco_otro',
    isImage: false,
    label: 'Otro rango de edad de Peñasco', // config_id: 10465
  },
  {
    var: 'edad_typica',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Typica', // config_id: 10467
  },
  {
    var: 'edad_typica_otro',
    isImage: false,
    label: 'Otro rango de edad de Typica', // config_id: 10468
  },
  {
    var: 'edad_villasarchir',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Villa Sarchir', // config_id: 10470
  },
  {
    var: 'edad_villasarchir_otro',
    isImage: false,
    label: 'Otro rango de edad de Villa Sarchir', // config_id: 10471
  },
  {
    var: 'inspeccion_variedadescacao',
    isImage: false,
    label: `¿Qué variedades de cacao se cultivan en ${generoParcelas('el', 'la')} ${etiquetaParcelas([
      'singular',
      'lowercase',
    ])} inspeccionada?`, // config_id: 10376
  },
  {
    var: 'edad_trinitario',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Trinitario', // config_id: 10377
  },
  {
    var: 'edad_trinitario_otro',
    isImage: false,
    label: 'Otro rango de edad de Trinitario', // config_id: 10378
  },
  {
    var: 'edad_forastero',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Forastero', // config_id: 10379
  },
  {
    var: 'edad_forastero_otro',
    isImage: false,
    label: 'Otro rango de edad de Forastero', // config_id: 10380
  },
  {
    var: 'edad_criollo',
    isImage: false,
    label: 'Seleccione el o los rangos de edades aproximadas de Criollo', // config_id: 10381
  },
  {
    var: 'edad_criollo_otro',
    isImage: false,
    label: 'Otro rango de edad de Criollo', // config_id: 10382
  },
];

export const INFO_INSPECCION_PARCELA = [
  {
    var: 'inspeccion_sombra_p',
    isImage: false,
    label: `Porcentaje (%) de cobertura de sombra en ${generoParcelas('el', 'la')} ${etiquetaParcelas(['singular', 'lowercase'])}`, // config_id: 10671
  },
  {
    var: 'inspeccion_sombra_reg',
    isImage: false,
    label: `¿Se hizo regulación de sombra en ${generoParcelas('el', 'la')} ${etiquetaParcelas(['singular', 'lowercase'])}?`, // config_id: 10674
  },
  {
    var: 'inspeccion_sombra_reg_fecha',
    isImage: false,
    label: 'Fecha en que se realizó la última regulación de sombra', // config_id: 10675
  },
  {
    var: 'inspeccion_sombra_reg_s',
    isImage: false,
    label: 'Superficie regulada', // config_id: 10676
  },
  {
    var: 'inspeccion_sombra_reg_i',
    isImage: false,
    label: '¿La regulación tiene impacto fuerte en la cobertura?', // config_id: 10678
  },
  {
    var: 'inspeccion_resiembra',
    isImage: false,
    label: '¿Se hizo resiembra árboles de sombra?', // config_id: 10681
  },
  {
    var: 'inspeccion_resiembra_cuantas',
    isImage: false,
    label: '¿Cuántos árboles de sombra resembró?', // config_id: 10682
  },
  {
    var: 'inspeccion_resiembra_fecha',
    isImage: false,
    label: 'Fecha de resiembra', // config_id: 10683
  },
  {
    var: 'inspeccion_resiembra_s',
    isImage: false,
    label: 'Superficie de resiembra', // config_id: 10684
  },
  {
    var: 'inspeccion_resiembra_sinona',
    isImage: false,
    label: '¿Realizó resiembra de plantas perdidas?', // config_id: 11814
  },
  {
    var: 'areatotal_ha',
    isImage: false,
    label: 'Área resembrada', // config_id: 11818
  },
  {
    var: 'fecha_resiembra',
    isImage: false,
    label: 'Fecha de resiembra', // config_id: 11820
  },
  {
    var: 'semivero_renovacion',
    isImage: false,
    label: '¿Realizó renovación de cafetales?', // config_id: 11620
  },
  {
    var: 'plantacion_renovacion_fecha',
    isImage: false,
    label: 'Fecha de última renovación', // config_id: 10723
  },
  {
    var: 'amp_ha',
    isImage: false,
    label: 'Área renovada', // config_id: 11816
  },
  {
    var: 'inspeccion_sup_cambios_mut',
    isImage: false,
    label: `¿${generoParcelas('El', 'La')} ${etiquetaParcelas(['singular', 'lowercase'])} aumentó o disminuyó en superficie?`, // config_id: 10318
  },
  {
    var: 'inspeccion_sup_cambios_razon_mut',
    isImage: false,
    label: `Explica por qué aumentó o disminuyó la superficie de ${generoParcelas('el', 'la')} ${etiquetaParcelas([
      'singular',
      'lowercase',
    ])}`, // config_id: 10319
  },
];

export const INFO_BOSQUES_ANP = [
  {
    var: 'parcela_bosque',
    isImage: false,
    label: `¿${generoParcelas('El', 'La')} ${etiquetaParcelas([
      'singular',
      'lowercase',
    ])} actual que inspecciona está dentro de un "Bosque"?`, // config_id: 10341
  },
  {
    var: 'conversionagricola1',
    isImage: false,
    label:
      'Del 1 de enero de 2014 en adelante, los bosques y otros ecosistemas naturales se han convertido a la producción agrícola u otros usos del suelo', // config_id: 12530
  },
  {
    var: 'conversionagricola2',
    isImage: false,
    label:
      'Del 31 de diciembre de 2020 en adelante, los bosques y otros ecosistemas naturales se han convertido a la producción agrícola u otros usos del suelo', // config_id: 12531
  },
  {
    var: 'arboles_conservados',
    isImage: false,
    label:
      '¿Se han conservado todos los árboles en el bosque, excepto cuando estos representan un peligro a las personas o la infraestructura?', // config_id: 10656
  },
  {
    var: 'fuego1',
    isImage: false,
    label: `¿Se usa fuego para preparar o limpiar ${generoParcelas('el', 'la')} ${etiquetaParcelas(['singular', 'lowercase'])}?`, // config_id: 12526
  },
  {
    var: 'tala',
    isImage: false,
    label: '¿El productor/a realizó tala de bosque primario para instalar nueva área de café?', // config_id: 11265
  },
  {
    var: 'tala_descripcion',
    isImage: false,
    label: 'Describa:', // config_id: 11266
  },
  {
    var: 'parcela_areareserva',
    isImage: false,
    label: `¿${generoParcelas('El', 'La')} ${etiquetaParcelas(['singular', 'lowercase'])} actual está dentro de un Área Natural Protegida?`, // config_id: 10338
  },
  {
    var: 'programa_manejo_oficial',
    isImage: false,
    label: '¿Sigue el Programa de Manejo Oficial (zonificación, poda, agroquímicos, variedades)?', // config_id: 10339
  },
  {
    var: 'parcela_areareserva_permiso',
    isImage: false,
    label: '¿Tiene autorización para cultivar en este sitio?', // config_id: 10340
  },
  {
    var: 'programa_manejo_oficial_folio',
    isImage: false,
    label: 'Número de folio del documento', // config_id: 10347
  },
  {
    var: 'programa_manejo_oficial_foto',
    isImage: true,
    label: 'Fotografía del documento', // config_id: 10348
  },
];

export const INFO_USO_SUELO_TENENCIA = [
  {
    var: 'tenencia_tierra',
    isImage: false,
    label: 'Tipo de tenencia de la tierra', // config_id: 10178
  },
  {
    var: 'tipo_ejidatario',
    isImage: false,
    label: 'Tipo de ejidatario', // config_id: 10179
  },
  {
    var: 'tenencia_papeles_sino',
    isImage: false,
    label: '¿Cuenta con papeles de la tenencia?', // config_id: 10198
  },
  {
    var: 'tenencia_papeles',
    isImage: false,
    label: '¿Qué tipo de papel de tenencia?', // config_id: 10199
  },
  {
    var: 'certificado_agrario_sino',
    isImage: false,
    label: '¿Cuenta con el certificado del Registro Agrario Nacional que lo acredite como ejidatario individual?', // config_id: 10180
  },
  {
    var: 'ejidatario_parcelario',
    isImage: false,
    label: '¿Con qué documento cuenta como ejidatario parcelario?', // config_id: 10183
  },
  {
    var: 'registro_agr_nacional_sino',
    isImage: false,
    label:
      '¿Cuentan con un instrumento notarial o validado por el Registro Agrario Nacional que acredite la constitución de la organización o empresa ejidal?', // config_id: 10186
  },
  {
    var: 'certificado_asamblea_sino',
    isImage: false,
    label: '¿Cuenta con un certificado de asamblea que respalde su derecho de uso de tierra comunal?', // config_id: 10189
  },
  {
    var: 'titulo_propiedad',
    isImage: false,
    label: '¿Cuenta con alguno de los siguientes documentos?', // config_id: 10192
  },
  {
    var: 'contrato_duenio',
    isImage: false,
    label: 'Si no es propietario, ¿tiene un contrato o permiso del dueño?', // config_id: 10195
  },
  {
    var: 'contrato_duenio_folio',
    isImage: false,
    label: 'Número de folio del documento', // config_id: 10196
  },
  {
    var: 'contrato_duenio_foto',
    isImage: true,
    label: 'Fotografía del documento', // config_id: 10197
  },
];

export const INFO_COLINDANTES_Y_RIESGOS = [
  {
    var: 'colindante_norte',
    isImage: false,
    label: '¿Con qué colinda el cafetal al NORTE?', // config_id: 11309
  },
  {
    var: 'riesgos_deforestacion_norte',
    isImage: false,
    label: '¿Existen riesgos de deforestación en este colindante para el cafetal inspeccionado?', // config_id: 11323
  },
  {
    var: 'riesgos_deforestacion_norte_si',
    isImage: false,
    label: 'Seleccione los riesgos identificados', // config_id: 11324
  },
  {
    var: 'riesgos_deforestacion_norte_si_otro',
    isImage: false,
    label: 'Otro', // config_id: 11325
  },
  {
    var: 'riesgos_deforestacion_foto_norte',
    isImage: true,
    label: 'Capture una foto del riesgo de deforestación en este colindante', // config_id: 11326
  },
  {
    var: 'acciones_productor_deforestacion_norte',
    isImage: false,
    label: '¿Qué hizo el productor/a para evitar el riesgo de deforestación?', // config_id: 11327
  },
  {
    var: 'colindante_sur',
    isImage: false,
    label: '¿Con qué colinda el cafetal al SUR?', // config_id: 11331
  },
  {
    var: 'riesgos_deforestacion_sur',
    isImage: false,
    label: '¿Existen riesgos de deforestación en este colindante para el cafetal inspeccionado?', // config_id: 11345
  },
  {
    var: 'riesgos_deforestacion_sur_si',
    isImage: false,
    label: 'Seleccione los riesgos identificados', // config_id: 11346
  },
  {
    var: 'riesgos_deforestacion_sur_si_otro',
    isImage: false,
    label: 'Otro', // config_id: 11347
  },
  {
    var: 'riesgos_deforestacion_foto_sur',
    isImage: true,
    label: 'Capture una foto del riesgo de deforestación en este colindante', // config_id: 11348
  },
  {
    var: 'acciones_productor_deforestacion_sur',
    isImage: false,
    label: '¿Qué hizo el productor/a para evitar el riesgo de deforestación?', // config_id: 11349
  },
  {
    var: 'colindante_este',
    isImage: false,
    label: '¿Con qué colinda el cafetal al ESTE?', // config_id: 11353
  },
  {
    var: 'riesgos_deforestacion_este',
    isImage: false,
    label: '¿Existen riesgos de deforestación en este colindante para el cafetal inspeccionado?', // config_id: 11367
  },
  {
    var: 'riesgos_deforestacion_este_si',
    isImage: false,
    label: 'Seleccione los riesgos identificados', // config_id: 11368
  },
  {
    var: 'riesgos_deforestacion_este_si_otro',
    isImage: false,
    label: 'Otro', // config_id: 11369
  },
  {
    var: 'riesgos_deforestacion_foto_este',
    isImage: true,
    label: 'Capture una foto del riesgo de deforestación en este colindante', // config_id: 11370
  },
  {
    var: 'acciones_productor_deforestacion_este',
    isImage: false,
    label: '¿Qué hizo el productor/a para evitar el riesgo de deforestación?', // config_id: 11371
  },
  {
    var: 'colindante_oeste',
    isImage: false,
    label: '¿Con qué colinda el cafetal al OESTE?', // config_id: 11375
  },
  {
    var: 'riesgos_deforestacion_oeste',
    isImage: false,
    label: '¿Existen riesgos de deforestación en este colindante para el cafetal inspeccionado?', // config_id: 11389
  },
  {
    var: 'riesgos_deforestacion_oeste_si',
    isImage: false,
    label: 'Seleccione los riesgos identificados', // config_id: 11390
  },
  {
    var: 'riesgos_deforestacion_oeste_si_otro',
    isImage: false,
    label: 'Otro', // config_id: 11391
  },
  {
    var: 'riesgos_deforestacion_foto_oeste',
    isImage: true,
    label: 'Capture una foto del riesgo de deforestación en este colindante', // config_id: 11392
  },
  {
    var: 'acciones_productor_deforestacion_oeste',
    isImage: false,
    label: '¿Qué hizo el productor/a para evitar el riesgo de deforestación?', // config_id: 11393
  },
];
